// extracted by mini-css-extract-plugin
module.exports = {"popover":"StylesActionMenu_popover__fSRhM","styles-option":"StylesActionMenu_styles-option__uGR_z","inputs-header":"StylesActionMenu_inputs-header__f3kqp"};